import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import { usePWA } from '../context/PWAContext';

export default function OfflineIndicator() {
  const { isOnline, pendingSyncCount } = usePWA();

  if (isOnline && pendingSyncCount === 0) return null;

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium transition-all ${
      isOnline 
        ? 'bg-gold/90 text-black' 
        : 'bg-red-500/90 text-white'
    }`}>
      {!isOnline ? (
        <>
          <WifiOff size={16} />
          <span>You're offline. Changes will sync when you're back online.</span>
        </>
      ) : pendingSyncCount > 0 ? (
        <>
          <RefreshCw size={16} className="animate-spin" />
          <span>Syncing {pendingSyncCount} pending change{pendingSyncCount > 1 ? 's' : ''}...</span>
        </>
      ) : null}
    </div>
  );
}
